import React from "react";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";

export interface SearchHandlerParams {
  setIsSearchChange: (value: boolean) => void;
  apiCallFunction: (page: number, limit: number) => void | Promise<void>;
  page: number;
  limit: number;
}

type SearchIconButtonProps = SearchHandlerParams

export const SearchIconButton: React.FC<SearchIconButtonProps> = ({
    setIsSearchChange,
    apiCallFunction,
    page,
    limit,
}) => {
    const handleClick = () => {
        setIsSearchChange(false);
        apiCallFunction(page, limit);
    };

    return (
        <IconButton onClick={handleClick}>
            <SearchIcon />
        </IconButton>
    );
};
